
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/technology-deployment/noc",
      function () {
        return require("private-next-pages/expertise/technology-deployment/noc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/technology-deployment/noc"])
      });
    }
  